import React from 'react';

function Privacy() {
  return (
    <main className="bg-white">
      <section className="pt-28 pb-14">
        <div className="max-w-4xl mx-auto px-6 space-y-12">
          <header>
            <h1 className="text-3xl sm:text-4xl font-semibold text-gray-900">Privacy Policy</h1>
            <p className="mt-3 text-gray-600 max-w-2xl">Your data is handled with care, confidentiality and transparency across our websites, portals and services.</p>
          </header>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">1. Scope</h2>
            <p className="mt-3 text-gray-600">This policy applies to visitors, prospective clients and clients interacting with our sites, applications and advisory services. It covers personal data processed as a controller and, where applicable, as a processor for certain partners.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">2. Data We Collect</h2>
            <ul className="mt-3 text-gray-700 space-y-2">
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Identification: name, address, email, phone, government IDs (where permitted).</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Account & suitability: employment, objectives, risk tolerance, financial profile.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Transactional: funding, withdrawals, custodial records, service interactions.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Technical: device, browser, IP, cookies, usage analytics, logs.</li>
            </ul>
            <p className="mt-3 text-gray-600 text-sm">We collect information directly from you, from third‑party verification services, and from your use of our services.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">3. Legal Bases</h2>
            <p className="mt-3 text-gray-600">We process data to perform a contract, comply with legal obligations (including KYC/AML), pursue legitimate interests (service improvement, security) and, where required, with your consent (marketing communications, certain cookies).</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">4. Use of Information</h2>
            <ul className="mt-3 text-gray-700 space-y-2">
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Provide and manage accounts, portfolios and client support.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Verify identity, prevent fraud, meet regulatory requirements.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Improve services, develop new features, and maintain security.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Communicate updates, statements and relevant offers (opt‑out anytime).</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">5. Sharing & Transfers</h2>
            <p className="mt-3 text-gray-600">We share data with custodians, payment providers, KYC vendors, auditors, and regulators where necessary. Cross‑border transfers are protected by appropriate safeguards such as standard contractual clauses or equivalent mechanisms.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">6. Cookies & Analytics</h2>
            <p className="mt-3 text-gray-600">We use essential cookies for site functionality and optional analytics to understand usage. You can manage preferences via your browser and, where available, our cookie banner.</p>
            <ul className="mt-3 text-gray-700 space-y-2">
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Strictly necessary: security, authentication, load balancing.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Performance: aggregate analytics to improve content and usability.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Preferences: remember settings such as language and region.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">7. Data Retention</h2>
            <p className="mt-3 text-gray-600">We retain personal data for as long as needed to provide services and meet legal obligations, including record‑keeping and regulatory requirements. Upon expiration, data is securely deleted or anonymized. Typical categories and periods include: account records (7–10 years post‑closure), compliance logs (5–7 years), marketing preferences (until opt‑out), and website analytics (12–26 months).</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">8. Security</h2>
            <p className="mt-3 text-gray-600">Controls include encryption in transit, access control, monitoring, segregation of duties, secure development practices, vulnerability management, and periodic testing. No system is perfectly secure; please safeguard your credentials.</p>
            <p className="mt-2 text-gray-600">In the event of a security incident affecting your data, we will investigate promptly and, where required, notify you and relevant authorities.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">9. Your Rights</h2>
            <p className="mt-3 text-gray-600">Subject to law, you may request access, correction, deletion, restriction, portability or object to certain processing. To exercise rights, contact us using the details below. We will verify your request and respond within applicable timelines.</p>
            <ul className="mt-3 text-gray-700 space-y-2">
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Right to know/access what we hold about you.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Right to rectify inaccuracies and update details.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Right to deletion, subject to legal retention requirements.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" /> Right to portability of certain data in a structured format.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">10. Children’s Privacy</h2>
            <p className="mt-3 text-gray-600">Our services are not directed to children. We do not knowingly collect data from minors without appropriate consent as required by law.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">11. Third‑Party Links</h2>
            <p className="mt-3 text-gray-600">Our sites may link to external resources. We are not responsible for their content or privacy practices. Review their policies before providing information.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">12. Changes to this Policy</h2>
            <p className="mt-3 text-gray-600">We may update this policy to reflect changes in law or our practices. Material changes will be highlighted on this page with an updated effective date.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">13. Automated Decisions & Profiling</h2>
            <p className="mt-3 text-gray-600">We do not make solely automated decisions with legal or similarly significant effects. Limited profiling may be used for fraud prevention and security.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">14. Jurisdiction‑Specific Notices</h2>
            <p className="mt-3 text-gray-600">Where local laws provide additional rights (e.g., GDPR/UK GDPR/CCPA), we honor those rights. Residents may have additional disclosure and opt‑out rights.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">15. Contact</h2>
            <p className="mt-3 text-gray-600">For privacy questions or requests, contact <a href="mailto:privacy@blockfirstcapital.com" className="text-[#0056d7] hover:underline">privacy@blockfirstcapital.com</a>.</p>
            <p className="mt-1 text-gray-500 text-sm">Last updated: {new Date().toLocaleDateString()}</p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Privacy;



